var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "submission-tabs-container" }, [
    _c(
      "ul",
      {
        staticClass: "row tabs hkld-tabs",
        attrs: { "data-tabs": "", id: _vm.id },
      },
      _vm._l(_vm.tabNames, function (tabName, index) {
        return _c(
          "li",
          {
            key: index,
            staticClass: "tabs-title column",
            class: { "is-active": index === 0 },
          },
          [
            _c(
              "a",
              {
                directives: [
                  { name: "checkVisibility", rawName: "v-checkVisibility" },
                ],
                style: _vm.extendStyleA,
                attrs: { href: "#comment-tab-" + index },
                on: { click: _vm.autoResize },
              },
              [_vm._v(_vm._s(tabName))]
            ),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "hkld-tabs-content",
        attrs: { "data-tabs-content": _vm.id },
      },
      [
        _c(
          "div",
          {
            staticClass: "tabs-panel is-active",
            style: _vm.extendStyleContent,
            attrs: { id: "comment-tab-0" },
          },
          [_c("div", { staticClass: "clearfix" }, [_vm._t("tab-0")], 2)]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tabs-panel",
            style: _vm.extendStyleContent,
            attrs: { id: "comment-tab-1" },
          },
          [_c("div", { staticClass: "clearfix" }, [_vm._t("tab-1")], 2)]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tabs-panel",
            style: _vm.extendStyleContent,
            attrs: { id: "comment-tab-2" },
          },
          [_c("div", { staticClass: "clearfix" }, [_vm._t("tab-2")], 2)]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tabs-panel",
            style: _vm.extendStyleContent,
            attrs: { id: "comment-tab-3" },
          },
          [_c("div", { staticClass: "clearfix" }, [_vm._t("tab-3")], 2)]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tabs-panel",
            style: _vm.extendStyleContent,
            attrs: { id: "comment-tab-4" },
          },
          [_c("div", { staticClass: "clearfix" }, [_vm._t("tab-4")], 2)]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }